// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"price_wrapper__SK0CP","original":"price_original__HnRfu","new":"price_new__MhJth"};